import { render } from "./view-account.vue?vue&type=template&id=be53b338&lang=html"
import script from "./view-account.vue?vue&type=script&lang=js"
export * from "./view-account.vue?vue&type=script&lang=js"

import "./view-account.vue?vue&type=style&index=0&id=be53b338&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__